var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 6.50004C2.5 4.84347 3.76518 3.5 5.32522 3.5H7.91651C8.9327 3.5 9.90564 3.93594 10.6147 4.70847L11.6565 5.84474C11.834 6.03787 12.0776 6.14755 12.331 6.14755H16.0974C18.0874 6.14755 19.7164 7.78538 19.8549 9.8592C21.1351 10.3851 21.8661 11.9592 21.3134 13.4273L19.5971 17.9855C19.025 19.5042 17.6397 20.5 16.099 20.5H6.26728C5.21754 20.5 4.26666 20.0425 3.58423 19.3084C2.91501 18.5875 2.50005 17.5937 2.50005 16.5006L2.5 6.50004ZM17.9284 9.67625C17.7297 8.79875 16.9855 8.14716 16.0973 8.14716H12.3309C11.569 8.14716 10.8389 7.81997 10.3074 7.2406L9.26558 6.10433C8.91067 5.71806 8.42419 5.49964 7.91653 5.49964H5.32524C4.80522 5.49964 4.38408 5.94777 4.38408 6.49997V14.9469L5.36142 11.75C5.7393 10.5135 6.82437 9.67627 8.049 9.67627L17.9284 9.67625ZM5.35437 18.2499L7.15279 12.3679C7.27904 11.9554 7.64013 11.6769 8.04891 11.6769H18.9215C19.4115 11.6769 19.7461 12.202 19.5642 12.6848L17.8479 17.2429C17.5618 18.0023 16.8697 18.5001 16.0989 18.5001H6.26714C5.93517 18.5001 5.62453 18.4093 5.35437 18.2499Z",
    fill: "#596780"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.b8b1b07a2bb90795cb6977a07ad6f182.svg";
export { ForwardRef as ReactComponent };